import script from "./PlaygroundChatBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaygroundChatBubble.vue?vue&type=script&setup=true&lang=js"

import "./PlaygroundChatBubble.vue?vue&type=style&index=0&id=20700503&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20700503"]])

export default __exports__